import React, { PureComponent } from 'react';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../../store';
import rootReducer from '../../reducer';
import history from './history';
import App from './App';
import 'css/style.less';
// Browser history
if (module && module.hot) {
    module.hot.accept('../../reducer', () => {
        store.replaceReducer(rootReducer);
    });
}

export default class Root extends PureComponent {
    render() {
        return (
            <Provider store={store}>
                <Router history={history}>
                    <App store={store} />
                </Router>
            </Provider>
        );
    }
}



// WEBPACK FOOTER //
// ./data/common/Root.js